// src/pages/admin/AdminHome.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const AdminHome: React.FC = () => {
    return (
        <div className="flex h-screen bg-gray-100">
            {/* Menu latéral */}
            <aside className="w-64 bg-blue-900 text-white shadow-lg">
                <div className="p-4 font-bold text-xl border-b border-gray-700">
                    Admin Tournoi360
                </div>
                <nav className="mt-4">
                    <ul className="space-y-2">
                        <li>
                            <Link to="/admin/mailing" className="block px-4 py-2 hover:bg-blue-700 rounded-md">
                                📧 Envoi de mails
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/club" className="block px-4 py-2 hover:bg-blue-700 rounded-md">
                                Gestion des Clubs
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/tournoi" className="block px-4 py-2 hover:bg-blue-700 rounded-md">
                                Gestion des Tournois
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/categorie" className="block px-4 py-2 hover:bg-blue-700 rounded-md">
                                Gestion des Catégories
                            </Link>
                        </li>                                                
                        <li>
                            <Link to="/admin/epreuve" className="block px-4 py-2 hover:bg-blue-700 rounded-md">
                                Gestion des Épreuves
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/ligue" className="block px-4 py-2 hover:bg-blue-700 rounded-md">
                                Gestion des Ligues
                            </Link>
                        </li>
                    </ul>
                </nav>
            </aside>

            {/* Contenu principal */}
            <main className="flex-1 p-6">
                <h1 className="text-2xl font-bold text-gray-800">Bienvenue dans le tableau de bord administrateur</h1>
                <p className="mt-4 text-gray-600">
                    Sélectionnez une section dans le menu de gauche pour gérer vos données.
                </p>
            </main>
        </div>
    );
};

export default AdminHome;
